// Web mock for pinar (carousel component)
import React, { useState } from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity, Text } from 'react-native';

interface PinarProps {
  children?: React.ReactNode;
  style?: any;
  showsControls?: boolean;
  showsDots?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  autoplayInterval?: number;
  index?: number;
  onIndexChanged?: (index: number) => void;
  containerStyle?: any;
  dotStyle?: any;
  activeDotStyle?: any;
}

const Pinar: React.FC<PinarProps> = ({
  children,
  style,
  showsDots = true,
  onIndexChanged,
}) => {
  const childrenArray = React.Children.toArray(children);
  const [currentIndex, setCurrentIndex] = useState(0);

  const goTo = (index: number) => {
    const newIndex = Math.max(0, Math.min(index, childrenArray.length - 1));
    setCurrentIndex(newIndex);
    onIndexChanged?.(newIndex);
  };

  return (
    <View style={[styles.container, style]}>
      <View style={styles.slideContainer}>
        {childrenArray[currentIndex]}
      </View>
      {showsDots && childrenArray.length > 1 && (
        <View style={styles.dotsContainer}>
          {childrenArray.map((_, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => goTo(index)}
              style={[
                styles.dot,
                index === currentIndex && styles.activeDot,
              ]}
            />
          ))}
        </View>
      )}
      {childrenArray.length > 1 && (
        <View style={styles.navContainer}>
          <TouchableOpacity
            onPress={() => goTo(currentIndex - 1)}
            style={styles.navButton}
            disabled={currentIndex === 0}
          >
            <Text style={styles.navText}>{'‹'}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => goTo(currentIndex + 1)}
            style={styles.navButton}
            disabled={currentIndex === childrenArray.length - 1}
          >
            <Text style={styles.navText}>{'›'}</Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  slideContainer: {
    flex: 1,
    overflow: 'hidden',
  },
  dotsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#ccc',
    marginHorizontal: 4,
  },
  activeDot: {
    backgroundColor: '#E30613',
  },
  navContainer: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 8,
  },
  navButton: {
    backgroundColor: 'rgba(0,0,0,0.3)',
    borderRadius: 20,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  navText: {
    color: 'white',
    fontSize: 20,
    fontWeight: 'bold',
  },
});

export default Pinar;
